module.exports = __webpack_public_path__ + "img/product-placeholder.ddc77f16.png";